/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import Drawer from 'components/Drawer';
import Brand from 'components/_base/Brand';
import LoggedUser from 'components/LoggedUser';
import Notifications from 'components/Notifications';
import NotificacaoChamados from 'components/NotificacaoChamados';

import './styles.scss';

const HeaderApp = () => {
  return (
    <header className="header-app">
      <Drawer />
      <div className="brand-app">
        <div>
          <a href="/">
            <Brand white />
          </a>
        </div>
        {/* <p className="text-mais-imagens">
          MAIS QUE <br />
          IMAGENS
        </p> */}
      </div>
      <LoggedUser />
      <NotificacaoChamados />
      <Notifications />
    </header>
  );
};

export default HeaderApp;
